import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import React from "react";
import "../../../../../../Component/Navigation/Navigation.css";
import TextArea from "../../../../../../Component/Material-ui/TextArea";
import TextField from "../../../../../../Component/Material-ui/TextField";
import { instance } from "../../../../../../Actions/AxiosInstance";
import "./index.css";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";

export default class AdvancedRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      totalamount: "",
      currencyList: [],
      "currencyconversionlogid": null,
      "conversionrate": null,
    };
    this.onSave = this.onSave.bind(this);
    this.setValue = this.setValue.bind(this);
    this.setValue1 = this.setValue1.bind(this);
  }

  componentDidMount() {
    this.GetApproverList();
    this.getCurrency();
  }

  getCurrency() {
    instance
    .get(`subscription/getcurrencyconversionlist`)
    .then((result) => {
      this.setState({
        currencyList: result.data.result.map((x) => ({
          displayvalue: x.currencyconversionlogid,
          displayname: x.currencyacronym,
          ...x,
        })),
        "currencyconversionlogid": null,
        "conversionrate": result.data.result.find((x) => !x.currencyconversionlogid).conversionrate,
      });
    })
    .catch((error) => {
      const msg =
        error && error.response && error.response.data.error.message;
      // this.props.enqueueSnackbar(msg, {
      //   variant: "error",
      // });
    });
  }

  handleChange(value, key) {
    const selectedcurrency = this.state.currencyList.find((x) => x[key] == value);
    this.setState({
      [key]: value,
      selectedcurrency,
      conversionrate: selectedcurrency ? selectedcurrency.conversionrate : null,
    });
  }

  onSave() {
    const data = {
      employeeid: this.props.SelectedEmpData ? this.props.SelectedEmpData.displayvalue : this.props.AuthenticationAction.login.employeeid,
      expenserequesttypeid: 2,
      comment: this.state.comment,
      sendersourceid: 1,
      totalamount: this.state.totalamount,
      recipient: this.state.recipient,
      "currencyconversionlogid": this.state.currencyconversionlogid,
      "conversionrate": this.state.conversionrate,
    };
    if (this.isformValid()) {
      instance
      .post('requestcenter/createexpenseadvancerequest', data)
      .then(() => {
        this.props.enqueueSnackbar("Save successfully", {
          variant: "success",
        });
        this.props.toggleDrawer({ drawerStatus: false, reqType: "" });
      })
      .catch((error) => {
        const msg = error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
    } else {
      this.props.enqueueSnackbar("Please fill all details ", {
        variant: "error",
      });
    }
  }

   GetApproverList() {
    const data = {
      workflowfortypeid: 5,
      withadmin: true,
      employeeid: this.props.employeeid || this.props.AuthenticationAction.login.employeeid,
    };
    instance
      .post("leaves/employeeapprovalrecipients", data)
      .then((result) => {
        let recipient = [];
        for (const approver of result.data.result) {
          const approverObj = {
            approveremployeeid: approver.employeeid,
            levelid: approver.levelid,
          };
          recipient.push(approverObj);
        }
        if (recipient.length < 0) recipient = null;
        this.setState({ recipient });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }


  setValue(e, key) {
    if (key == "comment") {
      this.setState({ comment: e.target.value });
    } else if (key == "Amount") {
      console.log('(e, key: ', e, key);
      if (parseInt(e) < 1) {
        console.log('parseInt(e): ', parseInt(e));
        this.setState({ totalamount: "" });
      } else {
        this.setState({ totalamount: parseInt(e) });
      }
    } else {
      return;
    }
  }

  setValue1(e, key) {
    console.log('e, key: ', e, key);
    if ((key == "Amount")) {
      if (parseInt(e) < 1) {
        this.setState({ totalamount: "" });
      } else {
        this.setState({ totalamount: parseInt(e) });
      }
    }
  }

  isformValid() {
    if (this.state.comment !== "" && this.state.totalamount !== "") {
      if (!Number.isNaN(this.state.totalamount)) {
        return true;
      }
      return false;
    }
    return false;
  }

  render() {
    return (
      <div key="key" className="planner-right-drawer">
        <div className="padding-bottom-24">
          <span className="drawer-close-btn" onClick={() => this.props.toggleDrawer({ drawerStatus: false, reqType: "" })}>
            <svg
              onClick={this.closeDrawer}
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7
              16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89
              4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
              />
            </svg>
          </span>
          <span className="drawer-header">Create new advance request</span>
        </div>
        <Paper className="clear-float drawer-container">
          <div>
            <DynamicForm
              fields={selectinputconverter({
                value: this.state.currencyconversionlogid,
                options: this.state.currencyList,
                label: "Currency",
              })}
              onChange={(e) => this.handleChange(e, "currencyconversionlogid")}
            />
          </div>
          <div className="drawer-input-group">
            <p className="input-label">Advance amount</p>
            <TextField
              className="expense-cycle-input width100"
              margin="dense"
              variant="outlined"
              placeholder="Enter expense amount"
              onChange={(e) => this.setValue(e.target.value, "Amount")}
              onBlur={(e) => this.setValue1(e.target.value, "Amount")}
              InputProps={{
                inputProps: {
                  min: 1,
                },
              }}
              type="number"
              value={this.state.totalamount}
            />
          </div>
          <div className="drawer-input-group">
            <p className="input-label">Expense description</p>
            <TextArea
              className="width100 textcomment"
              style={{ height: 100 }}
              variant="outlined"
              onChange={(e) => this.setValue(e, "comment")}
              multiline
              value={this.state.comment}
            />
          </div>

        </Paper>
        <div className="action-btn-group">
            <Button
              color="primary"
              variant="contained"
              onClick={this.onSave}
            >
              Send Request
            </Button>
          </div>
      </div>
    );
  }
}
